module.exports = __webpack_public_path__ + "img/27_27.ebfd175f.png";